// --------------------------------------------------
//  FOLDERS — carpetas de archivos colapsables
//  El header es un div[role=button]; botones de vista aparecen solo cuando
//  la carpeta está abierta y están antes del chevron en el DOM.
// --------------------------------------------------

export function initFolders() {

  const folders = document.querySelectorAll('[data-folder]');

  folders.forEach((folder) => {
    const header   = folder.querySelector('[data-folder-toggle]');
    const body     = folder.querySelector('[data-folder-body]');
    const viewBtns = folder.querySelectorAll('[data-folder-view]');

    if (!header || !body) return;

    // ── Colapso (click + teclado) ─────────────────────────────
    function toggle() {
      const isOpen = folder.classList.toggle('_open');
      header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      body.hidden = !isOpen;
    }

    header.addEventListener('click', toggle);

    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    // ── Cambio de vista (grid / lista) ───────────────────────
    viewBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();           // no activar el colapso del header
        const view = btn.dataset.folderView;
        viewBtns.forEach((b) => b.classList.toggle('_active', b === btn));
        body.classList.toggle('_list-view', view === 'list');
      });
    });

  });

}
